import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import tools from '../tools';
import styles from '../styles.module.css';
import classNames from 'classnames';
import WhiteboardController from '../controllers/WhiteboardController';

const UndoRedoToolbar: React.FC = () => {
  const controller = useController(WhiteboardController);
  const { hasActiveObjectTransformation } = controller.state;
  const toolButtons = [tools.ToolUndo, tools.ToolRedo];

  return (
    <div
      className={classNames(styles.undoRedoToolbar, styles.toolbarCommon, {
        [styles.toolbarFade]: hasActiveObjectTransformation,
      })}
    >
      {toolButtons.map(tool => {
        const ButtonComponent = tool.buttonComponent();
        return <ButtonComponent key={tool.toolName} />;
      })}
    </div>
  );
};

export default ApplicationView(UndoRedoToolbar);
